import { get, onValue, set } from 'firebase/database'

import { watchlistRef } from './database'

export const notifyMe = async (email: string) => {
  const watchlist = (await get(watchlistRef)).val() ?? []
  const newWatchlist = new Set([...watchlist, email])
  await set(watchlistRef, Array.from(newWatchlist))
}

export const subscribeToWatchlist = async (cb: AnyFunction) =>
  onValue(watchlistRef, snapshot => {
    const data = snapshot.val()
    cb(data)
  })
